module.exports = Devices = [
  {
    "type": "Phone",
    "name": "Apple iPhone 5",
    "width": 320,
    "height": 568,
    "rotation": true
  },
  {
    "type": "Phone",
    "name": "Google Nexus 5",
    "width": 360,
    "height": 640,
    "rotation": true
  },
  {
    "type": "Phone",
    "name": "Apple iPhone 6",
    "width": 375,
    "height": 667,
    "rotation": true
  },
  {
    "type": "Phone",
    "name": "Google Nexus 4",
    "width": 384,
    "height": 640,
    "rotation": true
  },
  {
    "type": "Phone",
    "name": "Google Nexus 6",
    "width": 411,
    "height": 731,
    "rotation": true
  },
  {
    "type": "Phone",
    "name": "Apple iPhone 6 Plus",
    "width": 414,
    "height": 736,
    "rotation": true
  },
  {
    "type": "Phone",
    "name": "Nokia Lumia 1520",
    "width": 432,
    "height": 768,
    "rotation": true
  },
  {
    "type": "Tablet",
    "name": "Amazon Kindle Fire HD 7\"",
    "width": 480,
    "height": 800,
    "rotation": true
  },
  {
    "type": "Tablet",
    "name": "Google Nexus 7",
    "width": 600,
    "height": 960,
    "rotation": true
  },
  {
    "type": "Tablet",
    "name": "Microsoft Surface Pro",
    "width": 720,
    "height": 1280,
    "rotation": true
  },
  {
    "type": "Tablet",
    "name": "Apple iPad Air",
    "width": 768,
    "height": 1024,
    "rotation": true
  },
  {
    "type": "Tablet",
    "name": "Samsung Galaxy Tab 10.1\"",
    "width": 800,
    "height": 1280,
    "rotation": true
  },
  {
    "type": "Tablet",
    "name": "Apple iPad Pro 12.9\"",
    "width": 1024,
    "height": 1366,
    "rotation": true
  },
  {
    "type": "Laptop",
    "name": "Google Chromebook Pixel",
    "width": 1280,
    "height": 850,
    "rotation": false
  },
  {
    "type": "Laptop",
    "name": "Apple MacBook Air 11.6\"",
    "width": 1366,
    "height": 768,
    "rotation": false
  },
  {
    "type": "Laptop",
    "name": "Apple MacBook Air 13.3\"",
    "width": 1440,
    "height": 900,
    "rotation": false
  },
  {
    "type": "Laptop",
    "name": "Microsoft Surface Book",
    "width": 1500,
    "height": 1000,
    "rotation": false
  },
  {
    "type": "Laptop",
    "name": "Apple MacBook Pro 15.4\"",
    "width": 1680,
    "height": 1050,
    "rotation": false
  },
  {
    "type": "Desktop",
    "name": "Apple iMac 21.5\"",
    "width": 1920,
    "height": 1080,
    "rotation": false
  },
  {
    "type": "Desktop",
    "name": "Apple iMac 27\"",
    "width": 2560,
    "height": 1440,
    "rotation": false
  }
]



//////////////////
// WEBPACK FOOTER
// ./app/js/lib/devices.js
// module id = 181
// module chunks = 0